import { saveUser, clearUser, saveCollege, clearCollege } from '../common/js/cache'
import * as types from './mutation-types'


export const saveUserAction = function({commit}, query){
	commit(types.SET_USER, saveUser(query))
}

export const clearUserAction = function({commit}){
	commit(types.SET_USER, clearUser())
  commit(types.CLEAR_USER)
}

export const saveCollegeAction = function({commit}, query){
	commit(types.SET_COLLEGE, saveCollege(query))
}

export const clearCollegeAction = function({commit}){
	commit(types.SET_COLLEGE, clearCollege())
}


// WEBPACK FOOTER //
// ./src/store/actions.js